import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=40a3594e&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=40a3594e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a3594e",
  null
  
)

export default component.exports